import React, { useState, useRef, useEffect } from "react";
import "./css/home-page.css";
import "./css/home-responsive.css";
import Homebanner from "./home-banner.jsx";
import HomePortal from "./home-portal.jsx";
import HomeHeader from "./home-header.jsx";
import HomeAbout from "./home-about.jsx";
import HomeCountries from "./home-countries.jsx";
import HomeConnecting from "./home-connecting.jsx";
import HomeWhatWe from "./home-what-we.jsx";
import HomeSkills from "./home-skills.jsx";
import HomeChoose from "./home-choose.jsx";
import HomeFooter from "./home-footer.jsx";
import HomeCommunity from "./home-community.jsx";
import HomeJobListing from "./home-job-listing.jsx";
import HomeRightEmployer from "./home-right-employer.jsx";
import "animate.css";
import { backendApi } from "../../api/apiService";
export default function HomePage() {
  const [siteDetails, setSiteDetails] = useState([]);
  const[jobList,setJobList]=useState([]);
  const aboutRef = useRef(null);
  useEffect(() => {
    getSiteDetails();
  }, []);

  const getSearchData = (siteId) => {
    try {
      const api = {
        functionName: "jobSearching",
        site_id: siteId,
        params: '',
      };
      backendApi(api).then((data) => {
        setJobList(data.dataSet);
      });
    } catch (e) {
      console.error("Error found", e);
    }
  };

  const getSiteDetails = () => {
    const currentUrl = window.location.href;

    // Extract site ID from the URL
    const siteIdMatch = currentUrl.match(/\/(\d+)\/?$/);
    const siteId = siteIdMatch ? siteIdMatch[1] : "";

    // Extract web URL from the URL
    const webUrlMatch = currentUrl.match(/^(https?:\/\/[^\/]+)\/?/);
    const webUrl = webUrlMatch ? webUrlMatch[1] : "";
    var req = {
      functionName: "getSiteDetails",
      site_id: siteId ? siteId : "",
      web_url: webUrl ? webUrl : "",
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        setSiteDetails(response.dataSet[0]);        
        if(response.dataSet.length>0){
          getSearchData(response.dataSet[0].id)
        }
      } else {
        return false;
      }
    });
  };
  return (
    <div className="home-wrapper">
      <div className="home-inner-wrapper">
        <HomeHeader siteDetails={siteDetails} scrollToAbout={() => aboutRef.current.scrollIntoView({ behavior: 'smooth' })} />
        <Homebanner siteDetails={siteDetails} />
        <HomePortal />
        <div ref={aboutRef}>
          <HomeAbout />
        </div>
        <HomeCountries />
        <HomeConnecting />
        <HomeWhatWe />
        <HomeSkills />
        <HomeChoose />
        <HomeCommunity />
        <HomeJobListing jobList={jobList} />
        <HomeRightEmployer />
        <HomeFooter />
      </div>
    </div>
  );
}
